<template>
  <div id="recent-projects" class="mt-5 mx-10 mb-10">
    <v-row class="px-5">
      <v-col cols="auto">
        <h2 class="text-h5 project-title">Recent Projects</h2>
      </v-col>
    </v-row>
    <v-row v-if="projects.length >= 1">
      <v-col v-for="(project, index) in projects" :key="index" cols="12"  xs="12" sm="12" md="6" lg="4" xl="3" class="h-100">
        <div class="project-box">
          <ProjectCard :project="project" />
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-alert type="info" text="" variant="tonal" color="red">No Recent Projects Available.</v-alert>
      </v-col>
    </v-row>
    <v-row class="mx-1 d-flex flex-row justify-end">
      <v-btn  v-if="projects.length >= 8" elevated  class="white--text" color="#00B3FF" title="Add" :to="'/projects'" rounded>
        View all projects
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import ProjectCard from '@/components/dashboard/ProjectCard.vue';
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { ProjectService } from "@/services/project-service.js";

export default {
  components: {
    ProjectCard,
  },

  data: () => ({
    projects: [], 
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    snackColor: 'success',
  }),

  mounted() {
    this.getRecentProjects();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    getRecentProjects() {
      this.loading = true;
      ProjectService.getRecentProjects()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.projects = response.data.data;
          }
        })
        .catch(error => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
  },
};
</script>
